/**
 * 導師入駐 PC 首頁 — 繁體中文（嵌套結構，對應 t('mentorJoin.indexPc.…')）
 */
export default {
	banner: {
		title: "诚邀您成為全球人生導師",
		title2: "讓<span>智慧</span>點亮世界",
		titleM: "诚邀您成為全球人生導師",
		title2M: "讓<span>智慧</span>點亮世界",
		body: {
			title: "如果您：",
			text1: "· 擅长心理學、療愈身心、塔羅占星、東方玄學、精神舒緩等方向",
			text2: "· 能夠為客戶提供專業線上詻詢，幫助他人獲得自我認同",
			text3: "· 有自己的教學體系，標準化課程",
			text4: "· 希望拓展副業、獲得穩定收益",
			text5: "· 希望獲得全球化的客戶資源及曝光機會",
		},
		joinCta: "立即入駐",
	},
	section1: {
		sectionTitle: "先知命局：讓導師智慧<span>被看見、被信任、被轉化為事業價值。</span>",
		sectionTitle2: "平台為導師打造多元化價值轉化渠道，涵蓋即時諮詢、高價值連線、",
		sectionTitle3: "內容變現等核心場景，助導師將專業能力持續轉化為商業價值。",
		sectionTitleM:
			"平台為導師打造多元化價值轉化渠道，涵蓋即時諮詢、高價值連線、內容變現等核心場景，助導師將專業能力持續轉化為商業價值。",
		title1: "品牌支持",
		text1: "全媒體IP孵化計劃，助您出圈走向際，專屬運營與資源支持",

		title2: "全球支付",
		text2: "接入全球化支付體系，支持多幣種交易便捷無国界",
		title3: "科技賦能",
		text3: "Al數位化升級經營，SaaS工具與廣告賦能，把握數位轉型紅利",
		title4: "服務保障",
		text4: "24小時全天候技術支援，保障業務穩定運行、服務全程暢通",
	},
	section2: {
		sectionTitle: "入駐即享<span>專屬權益</span>，助力專業價值全面升級",
		title1: "專屬運營",
		text1: "配備專屬運營顧問一對一服務，提供全流程入駐支持，助您高效啟航、無憂入駐。",
		title2: "流量扶持",
		text2: "量身打造個人形象、推廣方案與IP定位，千萬級流量全域曝光",
		title3: "定製服務",
		text3: "支持上線個性化服務方案，充分釋放專業優勢，拓展更高價值的服務場景。",
		title4: "活動優先",
		text4: "享有平台大型活動優先參與權，搶佔品牌曝光機會，放大個人影響力與商業價值。",
	},
	join: {
		sectionTitle: "入駐流程",
		centerImageAlt: "先知命局",
		step1: {
			title: "提交入駐申請",
			desc: '點擊<span class="join-step-link" role="button" tabindex="0">「立即入駐」</span>按鈕，填\n寫基本資訊、老師資質，\n並完成專業能力測評。',
		},
		step2: {
			title: "等待平台審核",
			desc: "平台將對入駐資質與\n老師專業能力進行綜\n合審核，審核結果將\n於<span>10</span>個工作日內透\n過郵件通知。",
		},
		step3: {
			title: "完成認證簽約",
			desc: "審核通過後，完成身份認\n證與支付認證，並線上簽\n署合作協議。",
		},
		step4: {
			title: "開通專屬後台",
			desc: "添加營運人員聯繫方式，\n平台將為老師開通導師\n專屬後台帳號 。",
		},
		step5: {
			title: "上線諮詢服務",
			desc: "配置老師個性化服務內\n容，開始接收用戶諮詢，\n為用戶提供專業解答。",
		},
	},
	joinM: {
		step1: {
			title: "提交入駐申請",
			desc: '點擊<span class="join-step-link" role="button" tabindex="0">「立即入駐」</span>按鈕，填寫基本資訊、老師資質，並完成專業能力測評。',
		},
		step2: {
			title: "等待平台審核",
			desc: "平台將對入駐資質與老師專業能力進行綜合審核，審核結果將於<span>10</span>個工作日內透過郵件通知。",
		},
		step3: {
			title: "完成認證簽約",
			desc: "審核通過後，完成身份認證，並線上簽署合作協議。",
		},
		step4: {
			title: "開通專屬後台",
			desc: "添加營運人員聯繫方式，平台將為老師開通導師專屬後台帳號 。",
		},
		step5: {
			title: "上線諮詢服務",
			desc: "配置老師個性化服務內容，開始接收用戶諮詢，為用戶提供專業解答。",
		},
	},
	section3: {
		title: "老師推薦",
		desc: "讓專業被看見，讓價值被放大。聆聽導師們在先知命局平台實現突破的真實故事。",
	},
	section4: {
		title: "先知命局：<span>科技融合文化智慧，一站式健康與人生</span>規劃平台",
		dec1: "全球首個亞裔專屬文化健康超級應用，開創亞洲傳統智慧數字化健康指導新賽道。打造一個集內容引流 + ",
		dec2: "交易變現 + AI 服務於一體的健康伴侶超級 App，“內容到商業” 閉環的綜合健康生活方式平台。 ",
		decM: "全球首個亞裔專屬文化健康超級應用，開創亞洲傳統智慧數字化健康指導新賽道。打造一個集內容引流 + 交易變現 + AI 服務於一體的健康伴侶超級 App，“內容到商業” 閉環的綜合健康生活方式平台。",
		decM2: "",
		dec3: "先知命局集團公司總部位於香港，分公司遍布新加坡、馬來西亞、台灣。",
		beimei: "北美 15%",
		qita: "其他地區 25%",
		dongnanya: "東南亞 50%",
		rihan: "日韓 10%",
	},
	teacherCircle: {
		title: "全球範圍入駐",
		dec: "全球合作超過",
		dec2: ">200 Mentor",
	},
	cooperativeMedia: {
		title: "合作媒體",
		groupTv: "電視臺 / 廣播電視臺",
		groupPlatform: "電視媒體平臺",
		groupChannel: "新媒體全管道",
		groupMedia: "報章 + 網媒",
	},
	section5: {
		sectionTitle: "明星導師",
		title1: "楓燧-星級名師",
		text1:
			"楓燧榮獲香港《通靈之王 2》總冠軍，深耕四柱八字、易經風水、梅花易數等傳統術數，專為緣主梳理事業發展、人生格局與居家環境規劃，給予清晰落地、切實可行的趨勢指引與解決方案。",
		title2: "麥玲玲-星級名師",
		text2:
			"麥玲玲老師為香港最受歡迎的命理學家之一，精於推算姻緣、八字命理及家居風水。她以貼地生動的風格，將傳統智慧融入現代生活，深受大眾信赖。",
		title3: "法銘-星級名師",
		text3:
			"法銘擅長以「天眼通」與祝由術進行根源診斷，結合奇門遁甲、八字風水，解讀無形糾纏，為用戶提供轉運方案。",
		title4: "趙振鴻-星級名師",
		text4:
			"趙振鴻擅長將八字、風水等深奥學理，轉化為清晰易懂的生活指引。專注為客戶的事業、感情及家宅環境，提供具建設性的解決方案。",
		title5: "林鶴-星級名師",
		text5:
			"林鶴師傅被譽為「年輕人的風水軍師」，擅長以現代語言與年輕視角，重新詮釋八字、風水、梅花易數等傳統智慧。",
	},
	loginModal: {
		tabEmail: "郵箱登錄",
		tabPhone: "手機號登錄",
		mPrivacy: "我們會保障您的隱私，其他人不會看到這項資料。",
		mPhoneStepTitle: "輸入您的手機號碼",
		mEmailStepTitle: "輸入您的郵箱",
		mAreaCodeLabel: "區號",
		mSwitchToEmail: "使用電郵地址註冊/登錄 >",
		mSwitchToPhone: "使用手機號註冊/登錄 >",
		mNext: "下一步",
		mInvalidEmail: "請輸入有效的電子郵箱",
		mVerificationTitle: "輸入驗證碼",
		mVerificationSentPrefix: "我們已發送驗證碼至",
		mResendWait: "重新發送驗證碼 ({n}) 秒",
		mResendLink: "重新發送驗證碼",
		mToastCodeSent: "驗證碼已發送",
		mToastCodeSendFail: "發送驗證碼失敗，請重試",
		mToastLoginCodeWrong: "登入失敗，請檢查驗證碼是否正確",
		mToastSelectAreaCode: "請選擇區號",
		mToastCompleteCaptcha: "請先進行人機校驗",
		mToastCaptchaFail: "驗證失敗，請重試",
		mToastCaptchaExpired: "驗證已過期，請重新驗證",
		mToastCaptchaUnsupported: "當前瀏覽器不支持驗證，請使用其他瀏覽器",
		mPhonePlaceholder: "輸入您的手機號碼",
		mEmailPlaceholder: "請輸入電郵",
		mCodePlaceholderPhone: "請輸入手機驗證碼",
		mCodePlaceholderEmail: "請輸入郵箱驗證碼",
		mGetCode: "獲取驗證碼",
		mLogin: "登錄",
		mBack: "返回上一步",
		bindTitle: "請輸入郵箱綁定賬號",
		bindDesc: "如有疑問，請聯繫客服",
		bindBtn: "綁定",
		kefu: "客戶支持",
		loginSuccess: "登入成功",
	},
	messagePop: {
		back: "返回",
		alreadyTeacher: {
			title: "歡迎加入SeerQ",
			desc: "您已成為 SeerQ 的签约老師，歡迎前往先知命局 App 接單、為用戶答疑解惑。",
		},
		notPass: {
			title: "很抱歉，您的老师资质审核暂未通过。",
			desc: "感谢您对平台的关注与申请。根据本次审核结果，当前暂无法继续完成入驻流程，感谢您的理解。",
		},
		inReview: {
			title: "老師資質認證中",
			desc: "您的資料已提交審核，審核期間相關信息無法更改。",
			desc2:
				"審核人員將於 10 個工作日內透過電子郵件回覆審核結果，敬請留意郵件收信。另可下載先知命局 App，即時接收審核進度與結果通知，感謝您的配合與支持。",
		},
	},
};
